import { useTranslation } from "react-i18next"

function loadLegal(locale) {
  try {
    return require(`@/generated/legal-${locale}.json`)
  } catch {
    return {}
  }
}

export function useLegalDoc(key) {
  const { i18n } = useTranslation()
  const locale = i18n.language?.startsWith("hu") ? "hu" : "ro"
  const docs = loadLegal(locale)
  return docs[key] || null
}
